import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SegmentViewModel } from '../model/segment-settings-model';
import { BaseService } from '../../../services/base-service';

const CONTROLLER = 'segment';
@Injectable({
  providedIn: 'root'
})
export class SegmentService extends BaseService {

  constructor(private http: HttpClient) {
    super();
  }

  public getSegments(listAll: boolean): Observable<SegmentViewModel[]> {
    return this.http.get<SegmentViewModel[]>(`${CONTROLLER}?listAll=${listAll}`)
      .pipe(
        map((response) => response),
        catchError(this.handleError)
      );
  }

  public getSegmentsUnfiltered(): Observable<SegmentViewModel[]> {
    return this.http.get<SegmentViewModel[]>(`${CONTROLLER}/unfiltered`)
      .pipe(
        map((response) => response),
        catchError(this.handleError)
      );
  }

  public deleteSegments(ids: number[]): Observable<number[]> {
    return this.http.put<number[]>(`${CONTROLLER}/inactivateOrDelete`, ids);
  }

  public addSegment(payload: any): Observable<any> {
    return this.http.post(CONTROLLER, payload);
  }

  public updateSegment(payload: SegmentViewModel): Observable<any> {
    return this.http.put(`${CONTROLLER}/${payload.id}`, payload);
  }

  public getSegmentWithUsers(id: number): Observable<SegmentViewModel> {
    return this.http.get<SegmentViewModel>(`${CONTROLLER}/${id}`);
  }

  public getIntegrationCode(): Observable<any> {
    return this.http.get<{ integrationCode: number }>(`${CONTROLLER}/getIntegrationCode`)
      .pipe(
        map((response: any) => response.integrationCode)
      );
  }
}
